<!-- @format -->

<template>
  <div>
    <div class="client-container">
      <div
        class="cbg"
        :style="
          'background: url(' +
            partnerBackgroundUrl +
            ') center center; background-size: cover;'
        "
      ></div>
      <div class="cbgmenu"></div>
      <div class="ui twelve column padded grid centered">
        <div class="row">
          <div class="twelve wide column">
            <div>
              <h2>Tool Settings</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="twelve wide column">
            <div class="ui">
              <div class="ui secondary pointing menu">
                <router-link to="/settings">
                  <div
                    v-bind:class="tab == 0 ? 'active' : ''"
                    class="item"
                    @click="showTab(0)"
                  >
                    Appearance
                  </div>
                </router-link>
                <router-link to="/settings">
                  <div
                    v-bind:class="tab == 1 ? 'active' : ''"
                    class="item"
                    @click="showTab(1)"
                  >
                    Fees
                  </div>
                </router-link>
                <router-link to="/settings">
                  <div v-if="appName != 'QuestLink'"
                    v-bind:class="tab == 2 ? 'active' : ''"
                    class="item"
                    @click="showTab(2)"
                  >
                    Portfolios
                  </div>
                </router-link>
                <router-link to="/settings">
                  <div
                    v-bind:class="tab == 3 ? 'active' : ''"
                    class="item"
                    @click="showTab(3)"
                  >
                    My Account
                  </div>
                </router-link>
                <router-link to="/settings">
                  <div
                    v-bind:class="tab == 4 ? 'active' : ''"
                    class="item"
                    @click="showTab(4)"
                  >
                    Advanced
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ui twelve column padded grid centered">
      <div v-if="tab == 0" class="row">
        <div class="twelve wide column">
          <div class="ui segment">
            <table class="ui table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Setting</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <strong>Background</strong>
                  </td>
                  <td>
                    <img
                      v-if="!showAvailableImages"
                      class="ui small img"
                      style="height: 100px;"
                      :src="partnerBackgroundUrl"
                    />
                    <br />
                    <button
                      v-if="!showAvailableImages"
                      @click="showAvailableImages = true"
                      class="ui button"
                    >
                      Change Team Background
                    </button>
                    <div v-if="showAvailableImages" class="ui segment">
                      <div class="ui link cards">
                        <div
                          @click="changeBackground(i)"
                          v-for="i in availableImages"
                          :key="i.name"
                          class="card"
                        >
                          <div class="image">
                            <img style="height: 90px" :src="i.url" />
                          </div>
                          <div class="content">
                            <div class="header">{{ i.name }}</div>
                          </div>
                        </div>
                      </div>
                      <br />
                      <button
                        v-if="showAvailableImages"
                        @click="showAvailableImages = false"
                        class="ui button"
                      >
                        Cancel
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Logo</strong>
                  </td>
                  <td>
                    <img
                      class="ui small img"
                      style="height: 100px;"
                      :src="partnerLogoUrl"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <FeeTable v-if="tab == 1" />
      <PortfolioFeeTable v-if="tab == 2" />
      <MyAccountTable v-if="tab == 3" />
      <div class="row" v-if="tab == 4">
        <div class="twelve wide column">
          <div class="ui attached message"><h2>Default Settings</h2></div>

          <AdvancedInputsV2
            :canEdit="true"
            v-if="tab == 4"
            :showLowestProjectedOutcome="showLowestProjectedOutcome"
            :moreLikelyZScore="moreLikelyZScore"
            :lessLikelyZScore="lessLikelyZScore"
            :isFundAlphaEqualToFees="isFundAlphaEqualToFees"
            :aaType="aaType"
            @handleZScoreChanged="handleZScoreChanged"
          />
          <div class="ui attached message">
            These are default settings. They can still be changed in the
            individual plans.
          </div>
          <div class="ui segment" v-if="showDefaultSettingsSave">
            <div class="ui large green button" @click="saveDefaultSettings">
              Save As Default
            </div>
            |
            <div class="ui large grey button" @click="cancelDefaultSettings">
              Cancel
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import FeeTable from "@/components/FeeTable.vue";

import { updatePartnerDefaultSettings, getPartnerSettings } from "@/gateway";
import PortfolioFeeTable from "@/components/PortfolioFeeTable.vue";
import AdvancedInputsV2 from "@/components/AdvancedInputsV2.vue";
import MyAccountTable from "@/components/MyAccountTable.vue";
export default {
  name: "partnerSettings",
  components: { FeeTable, PortfolioFeeTable, MyAccountTable, AdvancedInputsV2 },
  data() {
    return {
      tab: 0,

      showAvailableImages: false,
      disableForm: true,
      results: {},
      loading: false,
      message: null,
      availableImages: [
        {
          name: "Sailing",
          url:
            "https://assets.website-files.com/5c6eb35188c954830ec0365d/5c817444f2a0f7e7f938ae36_yacht-dtp.jpg",
        },
        {
          name: "Art",
          url:
            "https://assets.website-files.com/5c6eb35188c954830ec0365d/5c8176ebaab48661b95cd23b_pallette.jpg",
        },
        {
          name: "Hook",
          url:
            "https://assets.website-files.com/5c6eb35188c954830ec0365d/5c6eb35188c954c82fc036eb_hook-b.jpg",
        },
        {
          name: "Pen",
          url:
            "https://assets.website-files.com/5c6eb35188c954830ec0365d/5c6eb35188c95479a0c036ea_new-banner04.jpg",
        },
        {
          name: "Hammock",
          url:
            "https://assets.website-files.com/5c6eb35188c954830ec0365d/5c6eb35188c95444dbc036ee_hammock-02.jpg",
        },
        {
          name: "Coffee",
          url:
            "https://assets.website-files.com/5c6eb35188c954830ec0365d/5c6eb35188c95444c9c036c8_coffee-cream.jpg",
        },
      ],

      // defaults
      // adanved
      showDefaultSettingsMessage: "",
      showDefaultSettingsSave: false,
      moreLikelyZScore: null,
      lessLikelyZScore: null,
      showLowestProjectedOutcome: null,
      isFundAlphaEqualToFees: null,
      aaType: "Simple",
    };
  },
  methods: {
    async saveDefaultSettings() {
      const response = await updatePartnerDefaultSettings({
        showLowestProjectedOutcome: this.showLowestProjectedOutcome,
        moreLikelyZScore: this.moreLikelyZScore,
        lessLikelyZScore: this.lessLikelyZScore,
        isFundAlphaEqualToFees: this.isFundAlphaEqualToFees,
        aaType: this.aaType,
      });

      if (response) {
        this.showDefaultSettingsSave = false;
        this.showDefaultSettingsMessage = "Saved";
      }
    },
    async cancelDefaultSettings() {
      const response = await getPartnerSettings();
      if (response) {
        this.showDefaultSettingsSave = false;
        this.showDefaultSettingsMessage = "";
        this.moreLikelyZScore =
          response.partnerDefaultSettings.moreLikelyZScore;
        this.lessLikelyZScore =
          response.partnerDefaultSettings.lessLikelyZScore;
        this.showLowestProjectedOutcome =
          response.partnerDefaultSettings.showLowestProjectedOutcome;
        this.isFundAlphaEqualToFees =
          response.partnerDefaultSettings.isFundAlphaEqualToFees;
        this.aaType = response.partnerDefaultSettings.aaType;
      }
    },
    handleZScoreChanged(event) {
      this.showDefaultSettingsSave = true;
      this.moreLikelyZScore = event.moreLikelyZScore;
      this.lessLikelyZScore = event.lessLikelyZScore;
      this.showLowestProjectedOutcome = event.showLowestProjectedOutcome;
      this.isFundAlphaEqualToFees = event.isFundAlphaEqualToFees;
      this.aaType = event.aaType;
    },
    showTab: function(tabIndex) {
      this.tab = tabIndex;
    },
    editClick: function() {
      this.disableForm = !this.disableForm;
    },
    async saveClick() {
      this.disableForm = !this.disableForm;

      this.message = "Success";
    },
    changeBackground: function(img) {
      // partnerSettingsParams.partnerBackgroundUrl = img.url;
      // console.log(partnerSettingsParams);
      this.$store.dispatch("updateBackground", img.url);
      this.showAvailableImages = false;
      //this.$store.dispatch("loadSettings");
    },
    updatePartnerSettings: function() {
      var requestObject = {
        partnerBackgroundUrl:
          "https://assets.website-files.com/5c6eb35188c954830ec0365d/5c817444f2a0f7e7f938ae36_yacht-dtp.jpg",
        id: 1,
        partnerId: 2,
        partnerLogoUrl:
          "https://www.fussell.co.za/wp-content/uploads/2018/05/FUSSELL-VECTOR-LOGOS.png",
      };

      this.$store.dispatch("updateSettings", requestObject);
      //this.$store.dispatch("loadSettings");
    },
    async getResults() {
      this.loading = true;

      this.results = {};

      {
        this.moreLikelyZScore =
          this.partnerSettings.partnerDefaultSettings.moreLikelyZScore ||
          0.8416;
        this.lessLikelyZScore =
          this.partnerSettings.partnerDefaultSettings.lessLikelyZScore ||
          1.6449;
        this.showLowestProjectedOutcome =
          this.partnerSettings.partnerDefaultSettings
            .showLowestProjectedOutcome || true;

        this.isFundAlphaEqualToFees =
          this.partnerSettings.partnerDefaultSettings.isFundAlphaEqualToFees ||
          false;
        this.aaType =
          this.partnerSettings.partnerDefaultSettings.aaType || "Simple";
      }
      this.loading = false;
    },
  },
  computed: {
	  appName() {
		  if (this.$store.state.appName) return this.$store.state.appName;
		  else return "";
	  },
    partnerSettings() {
      return this.$store.state.partnerSettings;
    },
    partnerBackgroundUrl() {
      return this.$store.state.partnerBackgroundUrl;
    },
    partnerLogoUrl() {
      return this.$store.state.partnerLogoUrl;
    },
    ...mapState,
  },
  async mounted() {
    this.getResults();
  },
};
</script>
